import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { deleteCardTemplate } from '../redux/cardTemplateDbSlice';
import { deleteRelationUserCardTemplate } from '../redux/relationUserCardTemplateDbSlice';
import { deleteRelationPaletteCardTemplate } from '../redux/relationPaletteCardTemplateDbSlice';
import { deleteCardTemplateAttribute } from '../redux/cardTemplateAttributeDbSlice';
import { deleteCardTemplateShape } from '../redux/cardTemplateShapeDbSlice';
import { deleteNote } from '../redux/noteDbSlice';
import useOneCardTemplateValue from '../hooks/useOneCardTemplateValue';
import useRUCIdByCardTemplate from '../hooks/useRUCIdByCardTemplate';
import useRPCIdByPletteCardTemplate from '../hooks/useRPCIdByPletteCardTemplate';
import useCardTemplateAttributeDbs from '../hooks/useCardTemplateAttributeDbs';
import useCardTemplateShapeDbs from '../hooks/useCardTemplateShapeDbs';
import useNoteDbsByReferences from '../hooks/useNoteDbsByReferences';

type DeleteTemplateDialogProps = {
  open: boolean;
  onClose: () => void;
  paletteId?: string;
  cardTemplateId: string;
  updateOrder: (templateId: string) => void;
}
const DeleteTemplateDialog: React.FC<DeleteTemplateDialogProps> = ({open, onClose, paletteId, cardTemplateId, updateOrder}) => {
  const dispatch = useDispatch();
  const cardTemplate = useOneCardTemplateValue(cardTemplateId);
  const rucId = useRUCIdByCardTemplate(cardTemplateId);
  const rpcId = useRPCIdByPletteCardTemplate(paletteId, cardTemplateId);
  const [attributeIds] = useCardTemplateAttributeDbs(cardTemplateId);
  const [shapeIds] = useCardTemplateShapeDbs(cardTemplateId);
  const [noteIds] = useNoteDbsByReferences([cardTemplateId]);

  const deleteTemplateExe = () => {
    if (!cardTemplateId) return;
    updateOrder(cardTemplateId);
    dispatch(deleteCardTemplate({id: cardTemplateId}));
    dispatch(deleteRelationUserCardTemplate({id: rucId}));
    dispatch(deleteRelationPaletteCardTemplate({id: rpcId}));
    attributeIds.forEach(id => dispatch(deleteCardTemplateAttribute({id: id})));
    shapeIds.forEach(id => dispatch(deleteCardTemplateShape({id: id})));
    noteIds.forEach(id => dispatch(deleteNote({ id })))
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose}  maxWidth="xs" fullWidth>
      <DialogTitle>このカードテンプレートを削除します</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        { cardTemplate?.name }
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => deleteTemplateExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteTemplateDialog;
